import { render, staticRenderFns } from "./mobileFocusManage.vue?vue&type=template&id=12d66f6d&scoped=true"
import script from "./mobileFocusManage.vue?vue&type=script&lang=js"
export * from "./mobileFocusManage.vue?vue&type=script&lang=js"
import style0 from "./mobileFocusManage.vue?vue&type=style&index=0&id=12d66f6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d66f6d",
  null
  
)

export default component.exports